import React from 'react';
import {Redirect, Route, Switch} from 'react-router-dom';
import list from './list';
import stats from './stats';
import create from './create';

const BonusCards = ({match}) => (
  <div className="dashboard-wrapper">
    <Switch>
      <Redirect exact from={`${match.url}/`} to={`${match.url}/list`}/>
      <Route path={`${match.url}/list`} component={list}/>
      <Route path={`${match.url}/create`} component={create}/>
      <Route path={`${match.url}/:id`} component={stats}/>
      <Redirect to="/error"/>
    </Switch>
  </div>
);
export default BonusCards;
